import { usePostHttp } from "../../http.hook";

interface IResponse {
  success: boolean;
}

export function useReleaseEarningsAdminHttp() {
  return usePostHttp<null, IResponse>({
    path: "/admin/campaigns/:id/release-earnings",
  });
}
